import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import CodeMirrorEditor from 'components/editors/CodeMirrorEditor';
import { PrimaryBtn } from 'components/UI/Buttons';
import { type FC, useState } from 'react';
import type { FollowUpConfigDraft } from 'services/types/followUpConfig';

interface MessageContentSectionProps {
  followUpConfigDraft: FollowUpConfigDraft;
  isEditing: boolean;
  setFollowUpConfigDraft?: (followUpConfigDraft: FollowUpConfigDraft) => void;
}

const MessageContentSection: FC<MessageContentSectionProps> = ({
  followUpConfigDraft,
  isEditing,
  setFollowUpConfigDraft,
}) => {
  const [newSpecificText, setNewSpecificText] = useState('');

  if (followUpConfigDraft.prompt === null && followUpConfigDraft.specificTexts === null) {
    return null;
  }

  return (
    <Card sx={{ mb: 1.5, boxShadow: 0, borderRadius: 0 }}>
      <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
        <Typography variant="h6" gutterBottom sx={{ mb: 1.5, fontWeight: 600 }}>
          {followUpConfigDraft.prompt !== null && 'Instrucciones'}
          {followUpConfigDraft.specificTexts !== null && 'Textos específicos'}
        </Typography>
        {followUpConfigDraft.prompt !== null &&
          (isEditing ? (
            <CodeMirrorEditor
              value={followUpConfigDraft.prompt}
              onChange={(value) => setFollowUpConfigDraft?.({ ...followUpConfigDraft, prompt: value })}
              minHeight={180}
              maxHeight={400}
              ariaLabel="Instrucciones del follow up"
            />
          ) : (
            <CodeMirrorEditor
              value={followUpConfigDraft.prompt}
              onChange={() => undefined}
              readOnly
              maxHeight={400}
              ariaLabel="Instrucciones del follow up"
            />
          ))}
        {followUpConfigDraft.specificTexts !== null && (
          <Box>
            <Box sx={{ mb: 1.5, p: 1.5, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
              <Typography variant="body2" sx={{ fontFamily: 'monospace', color: '#212121' }}>
                [{followUpConfigDraft.specificTexts.join(', ')}]
              </Typography>
            </Box>
            {isEditing && (
              <Box
                sx={{
                  display: 'flex',
                  gap: 1,
                  alignItems: 'center',
                  flexWrap: 'wrap',
                }}
              >
                <TextField
                  size="small"
                  placeholder="Agregar texto específico"
                  onChange={(e) => setNewSpecificText(e.target.value)}
                  value={newSpecificText}
                  sx={{ flexGrow: 1, minWidth: '200px' }}
                />
                <PrimaryBtn
                  onClick={() => {
                    if (setFollowUpConfigDraft) {
                      setFollowUpConfigDraft({
                        ...followUpConfigDraft,
                        specificTexts: [...(followUpConfigDraft.specificTexts || []), newSpecificText],
                      });
                      setNewSpecificText('');
                    }
                  }}
                  variant="contained"
                  disabled={!newSpecificText.trim()}
                >
                  Agregar
                </PrimaryBtn>
                <PrimaryBtn
                  onClick={() => {
                    if (setFollowUpConfigDraft) {
                      setFollowUpConfigDraft({
                        ...followUpConfigDraft,
                        specificTexts: [...(followUpConfigDraft.specificTexts?.slice(0, -1) || [])],
                      });
                      setNewSpecificText('');
                    }
                  }}
                  variant="contained"
                  color="error"
                  disabled={!followUpConfigDraft.specificTexts || followUpConfigDraft.specificTexts.length === 0}
                >
                  Eliminar último
                </PrimaryBtn>
              </Box>
            )}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default MessageContentSection;
